import { Form } from 'factorial-form'

class StepForm extends Form {
  constructor(values: Record<string, string | number | undefined | null>) {
    super(values, {
      id: 'string',
      name: 'string',
      position: 'number',
      step_to_swap_id: 'string',
      before_or_after: 'string',
      offset_direction: 'string',
      offset_amount: 'number',
      progression_condition_resource_key: 'string',
      progression_condition: 'string',
    })
  }
}

export default StepForm
